<template>
  <div class="brand-card">
    <div class="brand-card-header">
      <ic-input
        size="sm"
        focus
        :placeholder="$t('helper.please-enter-a-keyword')"
        @input="fetchBrandList"
        v-model="brandSearchQuery"
        class="mb-20"
      />
      <ic-tab
        outlined
        @change="tabChange"
        :items="[
          { key: 'all', text: $t('common.all') },
          { key: 'favourite', text: $t('common.favourite') },
        ]"
      />
    </div>
    <div ref="scrollContainer" @scroll="handleScroll" class="brands">
      <b-overlay
        rounded
        opacity="0.7"
        spinner
        spinner-variant="primary"
        :show="brandsLoading"
      >
        <table class="ic-table">
          <thead>
            <tr>
              <th colspan="2">{{ $t('trade.symbol') }}</th>
              <th class="right">{{ $t('trade.price') }}</th>
              <th class="right">{{ $t('trade.change') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="tabKey === 'all'">
              <brand-item
                v-for="(item, i) in brands"
                :key="i"
                :selected="item.symbol === brand.symbol"
                :brand="item"
              />
            </template>
            <template v-else-if="tabKey === 'favourite'">
              <brand-item
                v-for="(item, i) in favoriteBrands"
                :key="i"
                :selected="item.symbol === brand.symbol"
                :brand="item"
              />
            </template>
          </tbody>
        </table>
      </b-overlay>
    </div>
  </div>
</template>

<style lang="scss" src="./BrandSelector.scss"></style>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import BrandItem from '../BrandItem.vue'
import brands from '../Brands.vue'

export default {
  name: 'app',
  data() {
    return {
      tabKey: 'all',
      brandSearchQuery: null,
      page: 1,
      isSearching: false,
      selectedBrand: null,
      stypeName: {
        1: this.$t('stock.stock'),
        2: this.$t('stock.bond'),
        3: this.$t('stock.bond-of-gov'),
      },
    }
  },
  created() {
    this.fetchBrandList = _.debounce(this.fetchBrandList, 100)
  },
  components: {
    'brand-item': BrandItem,
  },
  computed: {
    brands() {
      return brands
    },
    ...mapState('brand', [
      'stockType',
      'brand',
      'brands',
      'favoriteBrands',
      'brandsLoading',
      'isLastPage'
    ]),
    isSto() {
      return parseInt(this.stockType) === 2
    },
    isIpo() {
      return parseInt(this.stockType) === 1
    },
  },
  beforeDestroy() {
    if (this.isSto) this.unRegisterScrollEvent()
  },
  watch: {
    brand: {
      handler(bal) {
        this.isSearching = false
      },
    },
    page() {
      console.debug('page: ', this.page)
      this.fetchBrandList(this.page)
    },
    isSto(oldVal) {
      if (oldVal) {
        // this.$nextTick(() => this.registerScrollEvent())
      }
    },
    $route: {
      handler(val) {
        if (val.meta.isOther) {
          this.setStockType('3')
          this.stkType = '3'
        } else {
          let type = this.$route.name === 'trade-sto' ? '2' : '1'
          this.setStockType(type)
          this.stkType = type
        }
      },
    },
  },
  methods: {
    ...mapActions('brand', ['setBrand', 'setStockType', 'setFavoriteBrands']),
    handleScroll: function () {
      const scrollContainer = this.$refs.scrollContainer
      const scrollHeight = scrollContainer.scrollHeight
      const scrollTop = scrollContainer.scrollTop
      const clientHeight = scrollContainer.clientHeight
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        if (this.page <= this.isLastPage) this.page += 1
      }
    },

    tabChange(key) {
      this.tabKey = key
    },

    makeOrder() {
      document.getElementById('make-an-order').scrollIntoView()
    },

    unRegisterScrollEvent() {
      const container = this.$refs.container
      if (container) container.removeEventListener('scroll', () => {})
    },

    fetchBrandList(pageNumber) {
      this.$store.dispatch('brand/fetchBrands', {
        brandSearchQuery: this.brandSearchQuery,
        pageNumber: pageNumber ?? this.page
      })
    },
  },
}
</script>
